module.exports = __webpack_public_path__ + "static/media/landingCollaborator6.d80214f9.jpg";